import { flashWarningMessage } from 'app/globalMessages/globalMessagesClient';
import { clearDixaBrowserState } from 'app/utils/dixaReset';

const { accountLogoutUrl } = window.inlineGlobalConfig;

async function accountLogout(e) {
  e.preventDefault();
  clearDixaBrowserState();
  flashWarningMessage('ui.general.logout.notice');
  window.location.href = accountLogoutUrl;
}

export default accountLogout;
